// A simple toast implementation that shows messages in the console
// In a production app, you would use a proper toast library like react-hot-toast or react-toastify
export const toast = ({ title, description, variant = 'default', duration = 5000 }) => {
    // Log to console for development
    if (variant === 'destructive') {
        console.error(`[${title}] ${description}`);
    }
    else {
    }
    // Create a temporary toast element in the DOM
    const toastContainer = document.getElementById('toast-container');
    // If the toast container doesn't exist yet (e.g., if Toaster component hasn't mounted), create a temporary one
    if (!toastContainer) {
        return { id: Date.now().toString() };
    }
    const toastElement = document.createElement('div');
    toastElement.className = `p-4 rounded-md shadow-md mb-2 min-w-[250px] ${variant === 'destructive' ? 'bg-red-600 text-white' : 'bg-gray-800 text-white'}`;
    // SECURITY FIX: Use textContent instead of innerHTML to prevent XSS attacks
    const titleDiv = document.createElement('div');
    titleDiv.className = 'font-medium';
    titleDiv.textContent = title || '';
    const descDiv = document.createElement('div');
    descDiv.className = 'text-sm';
    descDiv.textContent = description || '';
    toastElement.appendChild(titleDiv);
    toastElement.appendChild(descDiv);
    toastContainer.appendChild(toastElement);
    // Add a subtle entrance animation
    toastElement.style.opacity = '0';
    toastElement.style.transform = 'translateX(20px)';
    toastElement.style.transition = 'opacity 0.3s, transform 0.3s';
    // Trigger animation after a small delay
    setTimeout(() => {
        toastElement.style.opacity = '1';
        toastElement.style.transform = 'translateX(0)';
    }, 10);
    // Remove the toast after specified duration
    setTimeout(() => {
        // Add exit animation
        toastElement.style.opacity = '0';
        toastElement.style.transform = 'translateX(20px)';
        // Remove after animation completes
        setTimeout(() => {
            if (toastElement.parentNode === toastContainer) {
                toastContainer.removeChild(toastElement);
            }
        }, 300);
    }, duration);
    return { id: Date.now().toString() };
};
// Type for useToast hook
export const useToast = () => ({ toast });
